
import rubyIcon from './images/icons/ruby.png';
import javaScriptIcon from './images/icons/javascript.png';
import pythonIcon from './images/icons/python.png';
import linuxIcon from './images/icons/linux.png';

import RubyMoreInfo from './more_info/Ruby';
import JavaScriptMoreInfo from './more_info/JavaScript';
import OtherLanguagesMoreInfo from './more_info/OtherLanguages';
import LinuxMoreInfo from './more_info/Linux';

import rubyImage from './images/ruby.jpg';
import javaScriptImage from './images/javascript.jpg';
import otherLanguagesImage from './images/other_languages.jpg';
import linuxImage from './images/linux.jpg';

import uxColWidthForItemsPerRow from '../../lib/uxColWidthForItemsPerRow';

const stacksList = [
  // ... first row
  [
    // ... 4 stacks per row
    [
      'ruby', 'Ruby', 'https://www.ruby-lang.org/en/',
      ['Ruby on Rails', 'RSpec'],
      rubyIcon,
      RubyMoreInfo,
      rubyImage
    ],

    [
      'java_script', 'JavaScript', 'https://www.javascript.com/',
      ['React', 'jQuery'],
      javaScriptIcon,
      JavaScriptMoreInfo,
      javaScriptImage
    ],

    [
      'other_languages', 'Other Languages', 'https://www.google.com/',
      ['Elixir/Phoenix', 'Python/Ansible', 'Perl', 'GoLang'],
      pythonIcon,
      OtherLanguagesMoreInfo,
      otherLanguagesImage
    ],

    [
      'linux', 'Linux, Etc.', 'https://www.kernel.org/',
      ['Bash', 'git'],
      linuxIcon,
      LinuxMoreInfo,
      linuxImage
    ]
  ],
].map(row => row.map(stackData => {
  return [
    'name', 'title', 'langURL', 'techList', 'icon', 'moreInfo', 'image'
  ].reduce((acc, key, ix) => {
    acc[key] = stackData[ix];
    return acc;
  }, {});
}));

export default (uxMaxColumnsPerRow) => ({
  list: stacksList,
  uxColumnWidthPerItem: uxColWidthForItemsPerRow(
    uxMaxColumnsPerRow, stacksList
  )
});



// WEBPACK FOOTER //
// ./src/components/stacks/stacks.js